export default "__VITE_ASSET__CMPqdJzz__"